import { FilterOption } from 'components/featured/Deals/types';
import { useCallback, useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';

export const useClientOptions = () => {
  const [clientOptions, setClientOptions] = useState<FilterOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalLength, setTotalLength] = useState(0);

  const fetchClients = useCallback(async (searchText?: string) => {
    try {
      setLoading(true);
      const data = await DealsService.getAllClients(searchText);
      const clients = data?.clients || (Array.isArray(data) ? data : []);
      const formattedClients = clients
        .map((item: any) => ({
          Name: item.Name || item.name || item.clientName || '',
          Id: item.AccountId || item.Id || item.id || item.clientId || '',
        }))
        .filter((item: any) => item.Name && item.Id);
      setClientOptions(formattedClients);
      setTotalLength(formattedClients.length);
    } catch (error) {
      console.error('Failed to fetch clients', error);
      setClientOptions([]);
      setTotalLength(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return {
    clientOptions,
    loading,
    totalLength,
    fetchClients,
  };
};
